import axiosInstance from '../config/axios.js';
import { getAuthToken } from '../utils/companyAccess.js';

const API_BASE = '/expenses';

const expenseService = {
  // Get all expenses with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get expense by ID
  getById: async (expenseId) => {
    const response = await axiosInstance.get(`${API_BASE}/${expenseId}`);
    return response.data;
  },

  // Create new expense
  create: async (expenseData, fileAttachment = null) => {
    const formData = new FormData();
    
    // Append all expense data
    Object.keys(expenseData).forEach(key => {
      if (expenseData[key] !== null && expenseData[key] !== undefined && expenseData[key] !== '') {
        formData.append(key, expenseData[key]);
      }
    });

    // Append file if provided
    if (fileAttachment) {
      formData.append('file_attachment', fileAttachment);
    }

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Update expense
  update: async (expenseId, expenseData, fileAttachment = null) => {
    const formData = new FormData();
    
    // Append all expense data
    Object.keys(expenseData).forEach(key => {
      if (expenseData[key] !== null && expenseData[key] !== undefined && expenseData[key] !== '') {
        formData.append(key, expenseData[key]);
      }
    });

    // Append file if provided
    if (fileAttachment) {
      formData.append('file_attachment', fileAttachment);
    }

    const response = await axiosInstance.put(`${API_BASE}/${expenseId}`, formData, {
      headers: {
        'Content-Type': undefined,
      },
    });
    return response.data;
  },

  // Delete expense
  delete: async (expenseId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${expenseId}`);
    return response.data;
  },

  // Get file attachment
  getFileAttachment: (expenseId) => {
    const token = getAuthToken();
    return `${axiosInstance.defaults.baseURL}${API_BASE}/${expenseId}/attachment${token ? `?token=${token}` : ''}`;
  },

  // Approve expense
  decide: async (expenseId, status, note) => {
    const response = await axiosInstance.post(`${API_BASE}/${expenseId}/decision`, {
      status,
      status_note: note,
    });
    return response.data;
  },

  approve: async (expenseId, remarks = '') => {
    const formData = new FormData();
    if (remarks) formData.append('remarks', remarks);
    
    const response = await axiosInstance.post(`${API_BASE}/${expenseId}/approve`, formData);
    return response.data;
  },

  // Mark expense as paid
  markAsPaid: async (expenseId, paymentData) => {
    const formData = new FormData();
    Object.keys(paymentData).forEach(key => {
      if (paymentData[key] !== null && paymentData[key] !== undefined && paymentData[key] !== '') {
        formData.append(key, paymentData[key]);
      }
    });

    const response = await axiosInstance.post(`${API_BASE}/${expenseId}/pay`, formData);
    return response.data;
  },

  // Get expense statistics
  getStatistics: async (params = {}) => {
    const response = await axiosInstance.get(`${API_BASE}/statistics`, { params });
    return response.data;
  },

  // Get monthly report
  getMonthlyReport: async (month, year) => {
    const response = await axiosInstance.get(`${API_BASE}/report/monthly`, {
      params: { month, year }
    });
    return response.data;
  },

  // Get all categories
  getCategories: async () => {
    const response = await axiosInstance.get(`${API_BASE}/categories`);
    return response.data;
  },

  // Get all months
  getMonths: async () => {
    const response = await axiosInstance.get(`${API_BASE}/months`);
    return response.data;
  }
};

export default expenseService;